import moment from 'moment'
import router from '../../router'
import { getQuery } from '../../modules/getQuery'

export const filters = {
  namespaced: true,
  state: {
    // 表示件数
    displayNumber: Number(getQuery('per') || localStorage.getItem('displayNumber') || 50),
    // 期間
    period: {
      startDate: sessionStorage.getItem('startDate') || moment().subtract(3, 'month'),
      endDate: sessionStorage.getItem('endDate') || moment()
    }
  },
  getters: {
    displayNumber: (state) => {
      return state.displayNumber
    },
  },
  mutations: {
    setDisplayNumber(state, payload) {
      state.displayNumber = payload
    },
    setPeriod(state, payload) {
      state.period = payload
    }
  },
  actions: {
    /**
     * 表示件数の変更
     * @param { Object } rootState
     * @param { Function } commit
     * @param { String | Number } payload
     * @return { Void }
     */
    async setDisplayNumber({ rootState, commit }, payload) {
      commit('setDisplayNumber', payload)

      // ローカルストレージへ格納
      localStorage.setItem('displayNumber', payload)

      // クエリ文字列の変更
      const query = { ...rootState.route.query, 'per': payload }
      await router.push({ query })
    },
    async setInitialDisplayNumber({ commit }, payload) {
      commit('setDisplayNumber', payload)
    },
    /**
     * 期間の変更
     * @param { Function } commit
     * @param { String | Number } payload
     * @return { Void }
     */
    setPeriod({ commit }, payload) {
      commit('setPeriod', payload)

      // セッションストレージへ格納
      sessionStorage.setItem('startDate', payload.startDate)
      sessionStorage.setItem('endDate', payload.endDate)
    }
  }
}
